import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ENTER_KEY, SPACE_KEYCODE } from '../../Utils/constant';
import { SelectMenuContext } from '../context';
import GroupedList from '../GroupedList';
import { SelectOptionTypes, getContainerHeight } from '../helper';
import VirtualizedList from '../VirtualizedList';
import styles from '@dtsl/css-select-menu/dist/index.module.css';
function SingleSelectionList(props) {
  let {
    options = [],
    onSelect = () => {},
    isControlButton = false,
    simpleSelectMenuTabIndex = null,
    isSubFolder = false
  } = props;
  const {
    setIsOpen,
    setIsOverlayOpen,
    selectedValues,
    setSelectedValues,
    isMobile,
    searchValue,
    handleSearch,
    enableVirtualization,
    onClose,
    isOpen,
    isOverlayOpen,
    scrollToSelectedValue
  } = useContext(SelectMenuContext);
  const setValue = (selectedObj, event) => {
    event.nativeEvent.stopImmediatePropagation();
    searchValue && handleSearch('');
    fireChangeEvent(selectedObj, event);
    !isControlButton && setSelectedValues([selectedObj]);
    isMobile ? setIsOverlayOpen(false) : setIsOpen(false);
    onClose(event, isMobile ? isOverlayOpen : isOpen);
  };
  const fireChangeEvent = (selectedObj, event) => {
    if (selectedObj !== (selectedValues[0] || {}) && onSelect) {
      onSelect(selectedObj, event);
    }
  };
  const onGroupMouseOver = event => {
    event.stopPropagation();
    event.preventDefault();
    const selectMenuWrapper = event.target.closest(styles['.sib-selectmenu']);
    Array.from(selectMenuWrapper.getElementsByClassName(styles['sib-selectmenu-option-group-header'])).forEach(parentNode => {
      Array.from(parentNode.querySelector(`.${styles['sib-selectmenu-option-group__header-content']}`).children).forEach(node => {
        node.classList.remove(styles['is-hovered']);
      });
    });
  };
  const getMouseOverFunc = optionType => {
    if (optionType === SelectOptionTypes.GROUP_LIST) {
      return onGroupMouseOver;
    }
  };
  const renderOption = (option, index, optionType, optionRef) => {
    let {
      key = index,
      icon = () => {},
      helpText,
      label,
      value,
      disabled = false,
      addtionalInfo = () => {},
      customLabelStyle = {}
    } = option;
    let isSelected = value === (selectedValues[0] || {}).value && label === (selectedValues[0] || {}).label && key === (selectedValues[0] || {}).key;
    const optionClass = classNames({
      [styles['sib-selectmenu-option']]: true,
      [styles['is-hovered']]: isSelected,
      [styles['selected']]: isSelected,
      [styles['locked']]: disabled,
      [option.className]: !!option.className,
      [styles['sib-is-selectmenu-virtualised-options']]: enableVirtualization
    });
    const labelClass = classNames({
      [styles['sib-selectmenu-option__label']]: true,
      [styles['sib-typo_text-body']]: !isSelected,
      [styles['sib-typo_text-body--bold']]: isSelected
    });
    const addInfo = addtionalInfo();
    const iconFunc = icon();
    if (scrollToSelectedValue && isSelected && !enableVirtualization) {
      const {
        align = 'start'
      } = scrollToSelectedValue;
      optionRef?.current?.scrollIntoView({
        block: align
      });
    }
    return (
      /*#__PURE__*/
      // eslint-disable-next-line data-test/onClick, data-test/onKeyDown
      React.createElement("li", {
        key: key || label || value,
        ref: isSelected ? optionRef : null,
        className: optionClass,
        onClick: !disabled ? event => {
          setValue(option, event);
        } : null,
        onKeyDown: event => {
          if ((event.key === ENTER_KEY || event.keyCode === SPACE_KEYCODE) && !disabled) {
            setValue(option, event);
          }
        },
        onFocus: getMouseOverFunc(optionType),
        role: 'option',
        'aria-selected': isSelected ? 'true' : 'false'
      }, /*#__PURE__*/React.createElement("div", {
        key: key,
        className: styles['sib-selectmenu-option__content'],
        disabled: disabled,
        title: label
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['sib-selectmenu-option__content-left']
      }, /*#__PURE__*/React.createElement("span", {
        className: labelClass
      }, iconFunc && /*#__PURE__*/React.createElement("span", {
        className: styles['sib-selectmenu-option__icon']
      }, icon()), /*#__PURE__*/React.createElement("span", {
        style: customLabelStyle
      }, label)), helpText && /*#__PURE__*/React.createElement("span", {
        className: `${styles['sib-selectmenu-option__helptext']} ${iconFunc ? styles['sib-add-space'] : ''}`
      }, helpText)), addInfo && /*#__PURE__*/React.createElement("span", {
        className: styles['additional-info']
      }, addtionalInfo())))
    );
  };
  let groupedListOptions = options.map((option, index) => {
    return /*#__PURE__*/React.createElement(GroupedList, {
      option: option,
      itemIndex: index,
      renderOption: renderOption,
      key: index
    });
  });
  const itemRenderer = (index, option) => {
    return /*#__PURE__*/React.createElement(GroupedList, {
      itemIndex: index,
      option: option,
      renderOption: renderOption,
      key: index
    });
  };
  const listHeight = useMemo(() => getContainerHeight(options, isSubFolder), [options, isSubFolder]);
  return /*#__PURE__*/React.createElement("ul", {
    className: styles['sib-selectmenu-options'],
    role: "presentation",
    tabIndex: simpleSelectMenuTabIndex
  }, enableVirtualization ? /*#__PURE__*/React.createElement(VirtualizedList, {
    data: options,
    itemContent: (index, option) => itemRenderer(index, option),
    isSubFolder: isSubFolder,
    defaultHeight: listHeight,
    scrollToSelectedValue: scrollToSelectedValue
  }) : groupedListOptions);
}
SingleSelectionList.propTypes = {
  isLoading: PropTypes.bool,
  onSelect: PropTypes.func,
  isSubFolder: PropTypes.bool,
  simpleSelectMenuTabIndex: PropTypes.number,
  noOptionContent: PropTypes.node,
  isControlButton: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    value: PropTypes.any,
    icon: PropTypes.func,
    helpText: PropTypes.string,
    addtionalInfo: PropTypes.func,
    customLabelStyle: PropTypes.object
  }))
};
export default SingleSelectionList;